@use "@fukuri-admins/ui/layout" as *;

.Root {
  &__Header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
  }

  &__Title {
    font-weight: 600;
    margin-bottom: 8px;
    font-size: 28px;
  }

  &__Actions {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 32px;
    margin-top: 7px;
  }

  .loading {
    display: flex;
    justify-content: center;
  }
}

.pushNotificationContent {
  .error {
    color: #ff0000;
    font-size: 12px;
  }


  form {
    .formContainer {
      margin-bottom: 24px;

      .formTitle {
        color: #767779;
        font-size: 14px;
        font-weight: 600;
        margin-bottom: 12px;
      }

      .symbol {
        color: #ff0000;
      }

      .input {
        display: block;
        width: 50%;
        color: #767779;
        font-size: 16px;
        font-weight: 400;
        border: 1px solid #dce5e5;
        border-radius: 4px;
        text-align: left;
        padding: 8px 12px;
        box-shadow: none;
        box-sizing: border-box;
      }

      select {
        line-height: 1.4;
        padding: 8px 12px;
        border-radius: 4px;
        font-size: 16px;
        border: 1px solid $Border;
        width: 50%;

        &:focus-visible {
          outline: none;
        }

        &:focus {
          outline: none;
        }
      }

      .registrationScheduleDatetimeContainer {
        width: 50%;
        display: flex;
        gap: 10px;
        align-items: center;
        margin-top: 16px;

        .timeInput {
          max-width: 50px;
        }
      }
    }

    .buttonContainer {
      display: flex;
      gap: 8px;
    }
  }
}

.modalContent {
  padding: 40px;
  background-color: white;
  border-radius: 8px;
  max-width: 650px;
  position: relative;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);

  .modalDescription {
    margin-bottom: 8px;
    color: #767779;
  }

  .errorMessage {
    color: red;
    font-family: "Noto Sans JP"; //20230111
    font-weight: 800;
    font-size: 14px;
    line-height: 22px;
    text-align: left;
  }

  .btnContainer {
    margin-top: 24px;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 8px;

    @media (max-width: 570px) {
      display: block;
    }
  }
}

.selectionInfoContainer {
  margin: 5px 0;
}

.selectionInfo {
  height: 48px;
  border: 1px solid #ccc;
  border-radius: 4px;
  padding: 10px 20px;
  color: #767779;
  font-size: 14px;
  display: flex;
  align-items: center;
  width: 100%;
  box-sizing: border-box;
}

.hidden {
  color: transparent;
  border-color: transparent;
}

.noMargin {
  padding-bottom: 0;
  margin-bottom: 0;
}

.checkboxLabel {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 0.5rem;
}

.checkbox {
  width: 1rem;
  height: 1rem;
}

.radioGroup {
  display: flex;
  gap: 1.5rem;
}

.radioLabel {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  cursor: pointer;
}

.radio {
  width: 1rem;
  height: 1rem;
  cursor: pointer;
}

.pager {
  margin-top: 16px;
}

.searchInputWrapper {
  width: 270px;

  // createSvgIcon 製アイコン（SearchIcon）は .svgIcon クラスが自前の color を持つため、
  // TextInput の startIcon スロット側の指定が継承で負ける。詳細度を上げて上書きする
  svg {
    color: inherit;
  }
}

.groupSelectContainer {
  margin-top: 16px;
  width: 50%;
}
